/**
 * Format the canonical submission UUID into the user-facing TRI-XXXXX
 * label. Until the backend exposes a numeric `submission_number`, we
 * derive a stable display id from the UUID itself:
 *
 *   1. Strip everything except digits → keep the last 5
 *   2. If the UUID has no digits at all (very rare), fall back to the
 *      last 5 alphanumeric characters of the trimmed id
 *   3. Prefix with `TRI-` and uppercase the result
 *
 * Used by the triage list (Submission ID column) and the submission
 * detail header so both surfaces stay in sync.
 */
export function formatSubmissionId(id: string | null | undefined): string {
    if (!id) return "—";
    const digits = id.replace(/\D/g, "");
    const tail = digits ? digits.slice(-5) : id.replace(/[^a-z0-9]/gi, "").slice(-5);
    return `TRI-${tail.toUpperCase()}`;
}
